<template>
    <div id="product-group-details-page">
        <spinner-text v-if="!productGroup">
            {{ trans('pages.product_group_details.loading') }}
        </spinner-text>
        <template v-else>
            <div class="productgroupdefaultfields">
                <p id="productgroupdetailscustomer">
                    {{ trans('pages.product_group_details.customer') }}
                    {{ productGroup.customerName }}
                </p>
            </div>

            <div
                class="productactions"
                id="productactions"
            >
                <div
                    class="productaction"
                    @click="$router.push('/productgrouppage/' + idParam)"
                >
                    <p class="productactiontitle">
                        {{
                            trans(
                                'pages.product_group_details.back_to_product_group'
                            )
                        }}
                    </p>
                    <div class="productactionimgdiv">
                        <i class="fa fa-arrow-left fa-3x" />
                    </div>
                </div>
            </div>

            <div>
                <div
                    class="productgroupProductDetails"
                    v-for="product in productGroup.groupProducts"
                    :key="'product.' + product.productId"
                >
                    <div class="leftcolumn">
                        <div class="productdefaultfields">
                            <div class="productpagefield">
                                <div
                                    :id="
                                        'productgroupdetailsid' +
                                        product.productId
                                    "
                                >
                                    {{
                                        trans(
                                            'pages.product_group_details.product_number'
                                        )
                                    }}
                                    {{ product.productId }}
                                </div>
                            </div>
                            <div class="productpagefield">
                                <div
                                    :id="
                                        'productgroupdetailsname' +
                                        product.productId
                                    "
                                >
                                    {{
                                        trans(
                                            'pages.product_group_details.name'
                                        )
                                    }}
                                    {{ product.name }}
                                </div>
                            </div>
                            <div class="productpagefield">
                                <div
                                    :id="
                                        'productgroupdetailsref' +
                                        product.productId
                                    "
                                >
                                    {{
                                        trans(
                                            'pages.product_group_details.reference'
                                        )
                                    }}
                                    {{ product.reference }}
                                </div>
                            </div>
                            <div class="productpagefield">
                                <div
                                    :id="
                                        'productgroupdetailsralnr' +
                                        product.productId
                                    "
                                >
                                    {{
                                        trans(
                                            'pages.product_group_details.ral_nr'
                                        )
                                    }}
                                    {{ product.color.ralnr }}
                                </div>
                            </div>
                            <div class="productpagefield">
                                <div
                                    :id="
                                        'productgroupdetailsraltype' +
                                        product.productId
                                    "
                                >
                                    {{
                                        trans(
                                            'pages.product_group_details.ral_type'
                                        )
                                    }}
                                    {{ product.color.raltype }}
                                </div>
                            </div>
                            <div class="productpagefield">
                                <div
                                    class="productgroupdetailsstatus"
                                    :id="
                                        'productgroupdetailsstatus' +
                                        product.productId
                                    "
                                >
                                    {{
                                        trans(
                                            'pages.product_group_details.status'
                                        )
                                    }}
                                    {{ product.productstatus }}
                                </div>
                            </div>
                            <template v-if="product.productstatus != 'GZ'">
                                <p id="productstatusnote">
                                    {{
                                        trans(
                                            'pages.product_group_details.status_warning'
                                        )
                                    }}
                                </p>
                            </template>
                            <p
                                class="productgroupdetailsnote"
                                :id="
                                    'productgroupdetailsnote' +
                                    product.productId
                                "
                            >
                                {{
                                    trans('pages.product_group_details.notes')
                                }}
                                {{ product.note }}
                            </p>
                        </div>
                        <div
                            class="productgroupdetailsfields"
                            :id="
                                'productgroupdetailsfields' + product.productId
                            "
                        >
                            <div
                                class="prodFormGroup"
                                v-for="group in product.groupedFields"
                            >
                                <div
                                    class="prodFormField"
                                    v-for="field in group"
                                >
                                    <span class="productpagename">
                                        {{ field.label }}
                                    </span>
                                    <span
                                        :class="
                                            field.emphOnProdForm == 1
                                                ? 'productpagevalueemph'
                                                : 'productpagevalue'
                                        "
                                    >
                                        <template v-if="field.datatype == 1">
                                            {{
                                                field.fieldvalue == 1
                                                    ? trans(
                                                          'pages.product_group_details.yes'
                                                      )
                                                    : trans(
                                                          'pages.product_group_details.no'
                                                      )
                                            }}
                                        </template>
                                        <template v-else>
                                            {{ field.fieldvalue }}
                                        </template>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="productactions"
                        id="productactions"
                    >
                        <div
                            @click="setProductDone(product.productId)"
                            class="productaction"
                            :id="'product' + product.productId + 'ofGroupDone'"
                        >
                            <p class="productactiontitle">
                                {{
                                    trans(
                                        'pages.product_group_details.finished'
                                    )
                                }}
                            </p>
                            <div class="productactionimgdiv">
                                <img
                                    class="productactionimg"
                                    :alt="
                                        trans(
                                            'pages.product_group_details.finished'
                                        )
                                    "
                                    src="images/productdone.png"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import SpinnerText from '../components/loader/SpinnerText';
import productApi from '../api/product';
import { groupFields } from '../shared/productDetails';
import IdParamMixin from '../mixins/id-param';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), NavigationFunctionsMixin, localization],
    components: { SpinnerText },
    data() {
        return {
            productGroup: null,
        };
    },
    methods: {
        setProductDone(pId) {
            this.setProductstatusDone(pId, '', 1);
        },
        load() {
            this.$store.commit(
                'general/setPageTitle',
                this.trans('pages.product_group_details.page_title', {
                    id: this.idParam,
                }),
                { root: true }
            );
            productApi.fetchExtendedDetails(this.idParam).then((response) => {
                const productGroup = response.data.data;
                productGroup.groupProducts.forEach((product) => {
                    product.groupedFields = groupFields(product.datafields);
                    delete product.datafields;
                });
                this.productGroup = productGroup;
            });
        },
    },
};
</script>
